function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2496 0.758431C10.9246 0.433431 10.3996 0.433431 10.0746 0.758431L5.99961 4.8251L1.92461 0.750098C1.59961 0.425098 1.07461 0.425098 0.749609 0.750098C0.424609 1.0751 0.424609 1.6001 0.749609 1.9251L4.82461 6.0001L0.749609 10.0751C0.424609 10.4001 0.424609 10.9251 0.749609 11.2501C1.07461 11.5751 1.59961 11.5751 1.92461 11.2501L5.99961 7.1751L10.0746 11.2501C10.3996 11.5751 10.9246 11.5751 11.2496 11.2501C11.5746 10.9251 11.5746 10.4001 11.2496 10.0751L7.17461 6.0001L11.2496 1.9251C11.5663 1.60843 11.5663 1.0751 11.2496 0.758431Z",
  fill: "#212C36"
});

var SvgBannerClose = function SvgBannerClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBannerClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/banner-close.4b5869c6.svg";
export { ForwardRef as ReactComponent };